import { Injectable, inject } from '@angular/core'
import { ResolveEnd, Router } from '@angular/router'

import { createEffect } from '@ngrx/effects'
import { RouterStateSerializer } from '@ngrx/router-store'

import { filter, map } from 'rxjs/operators'

import { StableRouterActions } from '../actions/stable-router.actions'

/**
 * Commits the stable router snapshot on ResolveEnd: after guards and resolvers pass but before
 * route activation, so components constructed during activation already see the new params, while
 * navigations rejected by a guard (e.g. PendingChangesGuard) never reach it.
 */
@Injectable()
export class StableRouterEffects {
  #router = inject(Router)
  #serializer = inject(RouterStateSerializer)

  navigationApproved$ = createEffect(() =>
    this.#router.events.pipe(
      filter((event): event is ResolveEnd => event instanceof ResolveEnd),
      map((event) =>
        StableRouterActions.navigationApproved({
          routerState: this.#serializer.serialize(event.state),
          navigationId: event.id,
        })
      )
    )
  )
}
